<template>
  <div class="d-flex">
    <div
      class="switch d-inline-block"
      :class="{ 'switch--checked': internalValue, 'me-2': hasLabel }"
      @click="handleChange"
    ></div>
    <input
      :id="componentId"
      v-model="internalValue"
      class="d-none"
      type="radio"
    />

    <!-- eslint-disable-next-line vuejs-accessibility/label-has-for -->
    <label v-if="hasLabel" :for="componentId" class="fs-tiny">
      <strong>{{ label }}</strong>
    </label>
    <!-- eslint-disable-next-line vuejs-accessibility/label-has-for -->
    <label v-else class="d-none" :for="componentId">
      Label for {{ componentId }}
    </label>
  </div>
</template>

<script lang="ts">
export default defineComponent({
  props: {
    modelValue: { type: Boolean, required: false, default: false },
    label: { type: String, default: '' },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const internalValue = ref<boolean>(props.modelValue);

    const handleChange = () => {
      internalValue.value = !internalValue.value;
      emit('update:modelValue', internalValue);
    };

    watch(
      () => props.modelValue,
      () => {
        internalValue.value = props.modelValue;
      },
    );

    const componentId = useId();

    const hasLabel = computed<boolean>(
      () => props.label != null && props.label.length > 0,
    );

    return { internalValue, handleChange, componentId, hasLabel };
  },
});
</script>

<style lang="scss" scoped>
@import 'gportal-theme/scss/colors';
// @TODO: should be moved to the new scss structure /bootstrap with sass variables
// for color and margin, border-radius, etc.

.switch {
  background: $gp-midnight-2;
  border-radius: 1.5rem;
  border: 1px solid $gp-rhino;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  cursor: pointer;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
  height: 1.5rem;
  width: 3rem;

  &::before {
    content: '';
    border-radius: 50%;
    width: calc(1.5rem - 2px);
    height: calc(1.5rem - 2px);
    background: $gp-rhino;
    -webkit-transition: all 0.4s ease-in-out;
    transition: all 0.4s ease-in-out;
    display: block;
  }

  &--checked {
    border-color: $gp-green;

    &::before {
      transform: translateX(1.5rem);
      background: $gp-green;
    }
  }
}
</style>
